module.exports = __webpack_public_path__ + "static/well_prmotion_marketing_agency-e45e240df5c79d1da5983a0620a4a7dc.jpg";